<template>
  <div>

    <div>
      <div style="display: flex; padding: 10px 0;">

        <div class="org-chart-filter">
          <el-switch v-model="horizontal"></el-switch> 横向
        </div>
        <div class="org-chart-filter" v-if="!isReadonly">
          <el-date-picker align="center" size="small" format="yyyy/MM/dd" v-model="searchDate" type="date" placeholder="选择筛选日期" @change="onSearchDatechange">
          </el-date-picker>
        </div>
        <!-- <div style="margin-right: 10px">
                    <el-switch v-model="collapsable"></el-switch> 可收起
                  </div>
                  <div style="margin-right: 10px">
                    <el-switch v-model="disaled"></el-switch> 禁止编辑
                  </div>
                  <div style="margin-right: 10px">
                    <el-switch v-model="onlyOneNode"></el-switch> 仅拖动当前节点
                  </div>
                  <div style="margin-right: 10px">
                    <el-switch v-model="cloneNodeDrag"></el-switch> 拖动节点副本
                  </div> -->
      </div>

      <!-- <div style="padding-bottom:10px">
                  背景色：
                  <el-color-picker v-model="style.background" size="small"></el-color-picker>&nbsp;
                  文字颜色：
                  <el-color-picker v-model="style.color" size="small"></el-color-picker>&nbsp;
                  搜索：
                  <input type="text" v-model="keyword" placeholder="请输入搜索内容" @keydown.enter="filter" />
                </div> -->

      <div class="org-chart-container">
        <zm-tree-org ref="tree" :data="data" :disabled="disaled" :horizontal="horizontal" :collapsable="collapsable"
          :label-style="style" :node-draggable="draggable" :default-expand-level="1" :only-one-node="onlyOneNode"
          :clone-node-drag="cloneNodeDrag" :before-drag-end="beforeNodeDragEnd" :toolBar="toolBar"
          :define-menus="customDefineMenus" :filterNodeMethod="filterNodeMethod" :node-edit="handleNodeEdit"
          :node-delete="handleNodeDelete" @on-node-drag="onNodeDragMove" @on-node-drag-end="onNodeDragEnd"
          @on-contextmenu="onMenus" @on-expand="onExpand" @on-node-click="onNodeClick"
          @on-node-dblclick="onNodeDblclick" @on-node-copy="onNodeCopy">
          <template #default="{node}">
            <div class="tree-org-node__text node-label" :class="getNodeTypeClass(node)">
              <div class="node-content">
                <table>
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <tr>
                    <td v-if="node.nodeType !== GLOBAL.enumOrgNodeType.Department">
                      <el-avatar :size="64" :src="getNodeAvatar(node)" />
                    </td>
                    <td>
                      <div class="node-content-right">
                        <el-row>
                          <el-col>
                            <div class="node-type" />
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col>
                            <span class="node-label">{{node.label}}</span>
                          </el-col>
                        </el-row>
                        <el-row v-if="node.nodeType === GLOBAL.enumOrgNodeType.Personnel">
                          <el-col>
                            <span>{{getPositionText(node)}}</span>
                          </el-col>
                        </el-row>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div v-if="!!node.manager" class="tree-org-node__text node-label" :class="getNodeTypeClass(node.manager)">
              <div class="node-content">
                <table>
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <tr>
                    <td v-if="node.manager.nodeType !== GLOBAL.enumOrgNodeType.Department">
                      <el-avatar :size="64" :src="getNodeAvatar(node.manager)" />
                    </td>
                    <td>
                      <div class="node-content-right">
                        <el-row>
                          <el-col>
                            <div class="node-type" />
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col>
                            <span class="node-label">{{node.manager.label}}</span>
                          </el-col>
                        </el-row>
                        <el-row v-if="node.manager.nodeType === GLOBAL.enumOrgNodeType.Personnel">
                          <el-col>
                            <span>{{getPositionText(node.manager)}}</span>
                          </el-col>
                        </el-row>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
          <template #expand="{node}">
            <span class="tree-org-node__expand-btn" :class="getNodeTypeClass(node)" />
          </template>
        </zm-tree-org>
      </div>
    </div>
    <orgDepartmentNodeEditor key="orgDepartmentNodeEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)"
      :readonly="isReadonly" :parentNode="parentNode" :data="editNode" />
    <orgPersonnelNodeEditor key="orgPersonnelNodeEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)"
      :readonly="isReadonly" :sasKey="sasKey" :positions="positionItems" :parentNode="parentNode" :data="editNode"
      @saveSuccess="handleOrgPersonnelNodeEditorSaveSuccess" />
  </div>
</template>

<script>
import { OrgChartNode } from "@/components/orgChart/orgChartNode";
import { getSharedAccessSignature } from "@/service/blobStorage.service";
import {
  getPositions,
  getOganization,
  removeDepartment,
  removePersonnelDepartment,
  movePersonnelToDepartment,
} from "@/service/oganization.service";
let moment = require("moment");
const mixin_general = {
  methods: {
    convertVMDataToOrgChartNodes(vmData) {
      let node = new OrgChartNode(vmData);
      if (node.nodeType === this.GLOBAL.enumOrgNodeType.Personnel) return node;

      if (vmData.Departments.length > 0) {
        for (let i = 0; i < vmData.Departments.length; i++) {
          let departmentData = vmData.Departments[i];
          let childNode = this.convertVMDataToOrgChartNodes(departmentData);
          node.childrenDepartment.push(childNode);
        }
      }

      if (vmData.Personnels.length > 0) {
        for (let i = 0; i < vmData.Personnels.length; i++) {
          let personnelData = vmData.Personnels[i];
          let childNode = new OrgChartNode(personnelData);
          node.childrenPersonnel.push(childNode);
          node.setToChildrenPersonnelEx(childNode);
        }
      }

      return node;
    },
    findParentNode(parentDataId, node = this.data) {
      if (node.dataId === parentDataId) return node;

      if (
        Object.typeOf(node.childrenDepartment) === "array" &&
        node.childrenDepartment.length > 0
      ) {
        for (let i = 0; i < node.childrenDepartment.length; i++) {
          let result = this.findParentNode(
            parentDataId,
            node.childrenDepartment[i]
          );
          if (!!result) return result;
        }
      }

      return null;
    },
    getNodeAvatar(node) {
      return node.avatarPath;
    },
    getNodeTypeClass(node) {
      let result = {};

      let nodeTypeKey = this.GLOBAL.enumOrgNodeType.getAttrValue(
        node.nodeType,
        "key"
      );
      if (!!nodeTypeKey) {
        result[nodeTypeKey] = true;
      }

      if (node.nodeType === this.GLOBAL.enumOrgNodeType.Personnel) {
        result["is-manager"] = !!node.meta && !!node.meta.isManager;
      }

      return result;
    },
    getPositionText(node) {
      if (
        !node.meta ||
        node.nodeType !== this.GLOBAL.enumOrgNodeType.Personnel ||
        this.positionItems.length === 0
      )
        return String.empty;

      let positionItem = this.positionItems.find(
        (item) =>
          item.Id === node.meta.positionId &&
          item.IsRoleType === node.meta.isRoleType
      );
      if (!positionItem) return String.empty;

      return positionItem.Name;
    },
    getChildrenCount(node) {
      let result = 0;

      if (!!node.children) result = node.children.length;

      return result;
    },
    isDragSelf(node, targetNode) {
      if (targetNode === node) return true;

      if (!!node.children && node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
          let result = this.isDragSelf(node.children[i], targetNode);
          if (result) return true;
        }
      }

      return false;
    },
  },
};

export default {
  name: "orgChartDiagram",
  mixins: [mixin_general],
  components: {
    navigator: () => import("@/components/navigator"),
    orgDepartmentNodeEditor: () =>
      import("@/components/orgChart/orgDepartmentNodeEditor"),
    orgPersonnelNodeEditor: () =>
      import("@/components/orgChart/orgPersonnelNodeEditor"),
  },
  data() {
    return {
      isReadonly: false,
      toolBar: {
        scale: false,
      },
      keyword: String.empty,
      sasKey: null,
      positionItems: [],
      data: {},
      horizontal: false,
      collapsable: true,
      onlyOneNode: false,
      cloneNodeDrag: false,
      expandAll: true,
      disaled: false,
      style: {
        background: "#fff",
        color: "#5e6d82",
      },
      parentNode: null,
      editNode: null,
      draggable: true,
      searchDate: ""
    };
  },
  created() {
    this.isReadonly =
      !this.USERMANAGER.isAdmin && !this.USERMANAGER.isPersonnelManagement;
    this.draggable = !this.isReadonly;
    this.init();
  },
  computed: {},
  methods: {
    async loadSharedAccessSignatureFromServer() {
      try {
        let result = await getSharedAccessSignature(true);
        if (!!result && result.success) {
          this.sasKey = result.data;
          OrgChartNode.blobSasKey = this.sasKey;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadPositionItemsFromServer() {
      try {
        let result = await getPositions();
        if (!!result && result.success) {
          this.positionItems = result.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async loadOganizationFromServer() {
      try {
        let date = '';
        if (this.searchDate){
          date = moment(this.searchDate).format("L");
        }
        
        let result = await getOganization(date);
        if (!!result && result.success) {
          this.data = this.convertVMDataToOrgChartNodes(result.data);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async removeDepartmentToServer(id) {
      try {
        let result = await removeDepartment(id);
        return !!result && result.success && result.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async removePersonnelDepartmentToServer(id) {
      try {
        let result = await removePersonnelDepartment(id);
        return !!result && result.success && result.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    async movePersonnelToDepartmentToServer(id, departmentId) {
      try {
        let result = await movePersonnelToDepartment(id, departmentId);
        if (!!result && result.success && !!result.data) {
          this.$message.success("移动人员成功");
          return result.data;
        } else {
          this.$message.error(`移动人员失败。${result.message}`);
        }
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async init() {
      await this.loadSharedAccessSignatureFromServer();
      await this.loadPositionItemsFromServer();
      await this.loadOganizationFromServer();
    },

    customDefineMenus(e, node) {
      let defineMenus = [
        {
          name: "复制文本",
          command: "copy",
        },
        {
          name: `${this.isReadonly ? "查看" : "编辑"}节点`,
          command: "edit",
        },
      ];

      if (!this.isReadonly) {
        if (!node.root) {
          defineMenus.push({
            name: "删除节点",
            command: "delete",
          });
        }

        if (node.nodeType === this.GLOBAL.enumOrgNodeType.Department) {
          defineMenus.push({
            name: "新增部门",
            command: "add-department",
          });
          defineMenus.push({
            name: "新增人员",
            command: "add-personnel",
          });
          defineMenus.push({
            name: !!node.manager ? "编辑负责人" : "新增负责人",
            command: !!node.manager ? "edit-manager" : "add-manager",
          });
          if (!!node.manager) {
            defineMenus.push({
              name: "删除负责人",
              command: "delete-manager",
            });
          }
        }
      }

      return defineMenus;
    },
    onMenus({ node, command }) {
      switch (command) {
        case "add-department":
          this.openOrgDepartmentNodeEditor(node, command);
          break;
        case "add-personnel":
        case "add-manager":
        case "edit-manager":
          this.openOrgPersonnelNodeEditor(node, command);
          break;
        case "delete-manager":
          this.handleNodeDelete(node, null, command);
          break;
      }
    },
    filter() {
      this.$refs.tree.filter(this.keyword);
    },
    filterNodeMethod(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onExpand(e, data) {
      // console.log(e, data);
      data.childrenPersonnel.forEach((item) => {
        this.$set(item, "expand", true);
      });
    },
    onNodeDragMove(data) {
      // console.log(data);
    },
    beforeNodeDragEnd(node, tagetNode) {
      if (!tagetNode) return false;

      if (this.isReadonly) {
        this.$message.error("没有权限执行移动操作。");
        return false;
      }

      if (node.nodeType === this.GLOBAL.enumOrgNodeType.Department) {
        this.$message.error("部门类型的节点不能被移动。");
        return false;
      }

      if (this.isDragSelf(node, tagetNode)) {
        this.$message.error("不能移动到自身。");
        return false;
      }

      if (!!tagetNode.children && tagetNode.children.contains(node)) {
        this.$message.error("已是目标节点的子节点，不能移动。");
        return false;
      }

      if (tagetNode.nodeType === this.GLOBAL.enumOrgNodeType.Personnel) {
        this.$message.error("不能移动到人员节点。");
        return false;
      }

      return new Promise((resolve, reject) => {
        this.$confirm(
          `您确认要移动该节点到 [${tagetNode.label}] 下吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(
          async () => {
            let newId = await this.movePersonnelToDepartmentToServer(
              node.dataId,
              tagetNode.dataId
            );
            if (!!newId) {
              await this.loadOganizationFromServer();
            }

            reject();
          },
          () => {
            reject();
          }
        );
      });
    },
    onNodeDragEnd(node, targetNode) {
      if (!targetNode.expand) this.$set(targetNode, "expand", true);
    },
    onNodeClick(e, data) {
      // this.$message.info(`单击节点：${data.label}`);
    },
    onNodeDblclick(e, data) {
      // this.$message.info(`双击节点：${data.label}`);
    },
    openOrgDepartmentNodeEditor(node, command) {
      let nodeEditor = this.$vueRefStore.getChildrenRef(
        "orgDepartmentNodeEditor"
      );
      if (!nodeEditor) return;

      if (command === "edit") {
        let parentNode = this.findParentNode(node.parentDataId);
        this.parentNode = parentNode;
        this.editNode = node;
      } else {
        this.parentNode = node;
        this.editNode = null;
      }

      nodeEditor.showDialog();
    },
    closeOrgDepartmentNodeEditor() {
      let nodeEditor = this.$vueRefStore.getChildrenRef(
        "orgDepartmentNodeEditor"
      );
      if (!nodeEditor) return;

      nodeEditor.closeDialog();
    },
    openOrgPersonnelNodeEditor(node, command) {
      let nodeEditor = this.$vueRefStore.getChildrenRef(
        "orgPersonnelNodeEditor"
      );
      if (!nodeEditor) return;

      if (command.startWith("edit")) {
        this.parentNode = null;
        this.editNode = command.contains("manager") ? node.manager : node;
      } else {
        this.parentNode = node;
        this.editNode = null;
      }

      nodeEditor.showDialog(command.contains("manager"));
    },
    closeOrgPersonnelNodeEditor() {
      let nodeEditor = this.$vueRefStore.getChildrenRef(
        "orgPersonnelNodeEditor"
      );
      if (!nodeEditor) return;

      nodeEditor.closeDialog();
    },
    async handleOrgPersonnelNodeEditorSaveSuccess() {
      await this.loadPositionItemsFromServer();
      await this.loadOganizationFromServer();
    },
    onNodeCopy() {
      this.$message.success("复制成功。");
    },
    handleNodeEdit(node) {
      switch (node.nodeType) {
        case this.GLOBAL.enumOrgNodeType.Department:
          this.openOrgDepartmentNodeEditor(node, "edit");
          break;
        case this.GLOBAL.enumOrgNodeType.Personnel:
          this.openOrgPersonnelNodeEditor(node, "edit");
          break;
      }
    },
    handleNodeDelete(node, parentNode, command = "") {
      if (!command.contains("manager") && !!node.root) {
        this.$message.error("不能删除根节点。");
        return;
      }

      let targetText = command.contains("manager") ? "负责人" : "节点";
      this.$confirm(`您确认要删除该${targetText}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(
        async () => {
          let result = false;
          switch (node.nodeType) {
            case this.GLOBAL.enumOrgNodeType.Department:
              if (command.contains("manager"))
                result = await this.removePersonnelDepartmentToServer(
                  node.manager.dataId
                );
              else result = await this.removeDepartmentToServer(node.dataId);
              break;
            case this.GLOBAL.enumOrgNodeType.Personnel:
              result = await this.removePersonnelDepartmentToServer(
                node.dataId
              );
              break;
          }
          if (result) this.loadOganizationFromServer();
        },
        () => { }
      );
    },
    expandChange() {
      this.toggleExpand(this.data, this.expandAll);
    },
    toggleExpand(data, val) {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          this.$set(item, "expand", val);
          if (!!item.children) {
            this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          this.toggleExpand(data.children, val);
        }
      }
    },
    onSearchDatechange(){
      this.loadOganizationFromServer();
    }
  },
};
</script>

<style lang="scss" scoped>
  .org-chart-filter{
    margin-right: 20px;
    line-height: 32px;
  }
.org-chart-container {
  border: 1px solid #eee;
  height: 440px;

  .tree-org-node__text {
    min-width: 210px;

    &.Department {
      background-color: #3a4651;
      color: #dcdfe6;

      .node-content {
        .node-content-right {
          text-align: center;
          margin-left: 0;
        }
      }
    }

    &.Personnel {
      &.is-manager {
        .node-content {
          .node-content-right {
            .node-type {
              background-color: #ff0000;
            }
          }
        }
      }
    }

    .node-content {
      overflow: hidden;

      table {
        width: 100%;

        col:nth-child(1) {
          width: 60px;
        }

        td:nth-child(1) {
          vertical-align: top;
          padding-top: 5px;
        }

        td:nth-last-child(1) {
          vertical-align: top;
        }
      }

      .node-content-right {
        margin-left: 10px;
        text-align: left;

        .node-type {
          display: block;
          width: 100%;
          margin: 5px 0;
          height: 3px;
          background-color: #dcdfe6;
        }

        .node-label {
          font-weight: bold;
        }
      }
    }
  }

  /deep/ .tree-org-node__expand {
    &:has(.Personnel) {
      display: none;
    }

    .icon-expand {
      width: 18px;
      height: 18px;
      color: #666;
      border-color: #666;
    }
  }
}

@media (min-width: 1600px) {
  .org-chart-container {
    height: 560px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orgChart/orgChartDiagram.vue